
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import api from '~/api/' // server
import SearchPeriod from '~/components/Common/UI/Search/SearchPeriod'
import SearchDate from '~/components/Common/UI/Search/SearchDate'
import SearchOnlyPeriod from '~/components/Common/UI/Search/SearchOnlyPeriod'
import List from '~/components/Common/UI/List_Board'
import Paging from '~/components/Common/UI/Paging'
import { getFileType } from '~/constants/NewsTypeURI'
import { arrSplit } from '~/utils/index'

export default {
    name: 'Blog',

    components: {
        SearchPeriod,
        SearchDate,
        SearchOnlyPeriod,
        List,
        Paging,
    },

    props: {
        newsType: String,
        menuType: {
            type: String,
            default: null,
        },
        pageTitle: String,
        date: {
            type: Boolean,
            default: false,
        },
        onlyperiod: {
            type: Boolean,
            default: false,
        },
        checkFirst: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            reqSize: 25,
            componentKey: 0,
            slotData: [],
            // 변경 중인 ..
            list: [],
            pageRowCount: 5,
            loadingStatus : false,
        }
    },

    computed: {
        ...mapState('paging', [
            'curPage',
            'blockLocation',
            'nextKey',
            'prevKey',
        ]),
        ...mapGetters('search', ['getSearch']),
        ...mapState ({
            MEMBER_INFO : state => state.member.memberInfo,
        }),
    },
    watch: {
        getSearch() {
            this.getList()
        },
    },
    created() {
        this.RESET_STORE()
        // console.log('newsType=', this.newsType) 

        // 22.05.17 suye 장중 특징주 및 특징테마 한페이지당 5->6개 reqSize 25->30
        if (this.newsType === 'MENU_MIDDLE_FEATURED') {
            this.reqSize = 30
            this.pageRowCount = 6 
        }
        // 22.05.17 suye 증시요약 한페이지당 5->10개 reqSize 25->50
        if (this.newsType === 'MENU_TODAY_SUMMARY') {
            this.reqSize = 50
            this.pageRowCount = 10 
        }

        if(this.newsType !== 'MENU_MAIN_EARNING'){ // 주요기업실적
            this.getList()
        } else {
            this.reqSize = 50
            this.pageRowCount = 10 
            this.getEarningList()
        }
        
    },
    /* 20210521 shb 추가 */

    methods: {
        ...mapMutations('paging', [
            'SET_PAGING',
            'SET_PREV_KEY',
            'SET_NEXT',
            'SET_PREV',
            'RESET_STORE',
        ]),
        ...mapActions('board', ['GET_CONTENT']),
        ...mapActions('modal', ['SHOW_ALERT', 'HIDE_MODAL']),

        async getEarningList(key) { // 22.09.28 suye 주요기업실적 
            const params = {
                menuType: this.newsType,
                count: this.reqSize,
                ...this.getSearch,
            }
            if (key) {
                if(key.length === 12){
                    key = key + '00'
                }
                params.nextKey = key
            }
            try{
                const res = (await api.getMainEarning(params))
                // console.log('res', res)

                const tempList = []
                Object.entries(res.data).forEach(([key, value]) => {
                    // console.log(key, value)  
                    const textTitle = key.substring(0,4) + '년 ' + key.substr(5,1) + '분기 주요 기업 실적'
                    tempList.push({nextKey: key, content: value, newsType1: 'MENU_MAIN_EARNING', title: textTitle})
                })
                tempList.sort((a, b) => { // 최근 분기순 정렬
                    if(a.nextKey > b.nextKey) { return -1 } 
                    if(a.nextKey < b.nextKey) { return 1 }
                }) 
                // console.log('tempList', tempList)    
                this.list = arrSplit(tempList, this.pageRowCount)   
                    this.SET_PAGING({
                        count: this.list.length,
                        block: 10, // this.pageRowCount
                        nextKey: this.list[0].nextKey,
                    })
                this.setContentEarning(tempList)
            } catch {
            }

        },
        
        setContentEarning(content){ // 주요기업실적
            this.slotData = content
        },

        async getList(key) {
            this.loadingStatus = true
            const params = {
                menuType: this.newsType,
                count: this.reqSize,
                ...this.getSearch,
            }
            if (key) {
                if(key.length === 12){
                    key = key + '00'
                }
                params.nextKey = key
            }
            try {
                await api.getBoardList(params).then((response) => {
                    const res = response.data
                    this.loadingStatus = false
                    if (res && res.items.length > 0) {
                    console.log('res.items' + JSON.stringify(res.items.length));
                    // 22.07.15 suye 기업 - 장중/장마감 주요종목공시 -> 장중이 앞서도록 정렬 
                    if(res.items[0].newsType1 === 'MARKET_STOCK_DISC_MIDDLE' || res.items[0].newsType1 === 'MARKET_STOCK_DISC_CLOSED'){
                        res.items.sort((a, b) => {
                            // 우선순위 showDate 내림차순 
                            if(a.showDate > b.showDate) return -1;
                            if(a.showDate < b.showDate) return 1;

                            // // 우선순위 newsType1 장중>장마감
                            if(a.newsType1 === 'MARKET_STOCK_DISC_MIDDLE' && b.newsType1 !== 'MARKET_STOCK_DISC_MIDDLE') return -1;
                            if(a.newsType1 !== 'MARKET_STOCK_DISC_MIDDLE' && b.newsType1 === 'MARKET_STOCK_DISC_MIDDLE') return 1;
                        });
                    }
                    this.list = arrSplit(res.items, this.pageRowCount)                
                    this.SET_PAGING({
                        count: this.list.length,
                        block: 5, // 22.05.20 suye 페이징 block this.pageRowCount->5
                        nextKey: res.nextKey,
                    })
                    this.setContent()
                    console.log('[check params] params.startDate: ', params.startDate, ', params.endDate: ', params.endDate);  
                    // 기간 선택이 아닌 경우 startDate가 일반 날짜 검색창으로 사용됨
                } else {
                    /* 
                        220317 meej
                        res.items = 0 일 경우 조회결과 없음 표시 
                    */                    
                    this.list = []
                    this.SET_PAGING({
                        count: 1,
                        block: 0,
                        nextKey: null,
                    })
                }
                })
                
            } catch (error) {
                /* 
                    220317 meej 
                    주석처리
                */
                // 22.02.24 한수예 
                // 기간 검색창 startDate alert창 대상 제외, 선택일자 - 현재일자 비교
                // const today = new Date();
                // const year = today.getFullYear();
                // const month = ('0' + (today.getMonth() + 1)).slice(-2);
                // const day = ('0' + today.getDate()).slice(-2);
                // const dateString = year + month + day;    
                // if (params.startDate && !params.endDate){       // startDate 존재 + endDate 미존재 
                //     if(dateString < params.startDate) {         // startDate - 현재일자 비교
                //         this.SHOW_ALERT({ content: '선택일자가 현재일자보다 클 수 없습니다.' })
                //         params.startDate = ''
                //     } 
                // } else {
                // this.SHOW_ALERT({ content: '해당 날짜의 데이터가 없습니다.' })
                this.list = []
                this.SET_PAGING({
                    count: 1,
                    block: 0,
                    nextKey: null,
                })
                console.log('blog_error=', error)
            // }
            }
        },

        onClickItem(values) {
            if(values && values.nextKey) { // 주요기업실적
                this.setContentEarning(values)
            } else {
                this.setContent(values)
            }
        },

        ContentData(data) {
            this.slotData = data
        },
        // 하위 컴포넌트 렌더링 문제
        forceRerender() {
            this.componentKey += 1
        },

        // 22.11.04 suye 수정 
        // 22.04.15 suye 기간제한일자 반환 함수: 오늘일자 - num => 기준일자 
        limitDateMaker(num){
            // 현재일자  
            const today = new Date();
            const year = today.getFullYear();
            const month = ('0' + (today.getMonth() + 1)).slice(-2);
            const day = ('0' + today.getDate()).slice(-2);

            // 현재일자 기준 -n일
            const dateLimit = new Date(year, Number(month)-1, day) 

            dateLimit.setDate(dateLimit.getDate() - num)

            // let limited = dateLimit.toLocaleDateString().replace(/\./g, '').replace(/(\s*)/g, "") // 일자 yyyyMMdd
            let limited = dateLimit.toLocaleDateString()
            // console.log('limited', limited)
            const changed = []
            const final = []
            if(limited.includes('.')){
                const splited = limited.split('.')
                if(splited.indexOf('') !== -1) splited.splice(splited.indexOf(''))
                // console.log('splited', splited)
                splited.forEach(e => {
                    changed.push(e.trim())
                });
            }
            if(changed && changed.length > 0){
                changed.forEach(e => {
                    if(e.length === 1){
                        e = '0'+e
                    }
                    final.push(e)
                });
            // console.log('final', final)
            }
            limited = final.join('')
            console.log('limited', limited)

            return limited
        },

        async setContent(values) {
            // targetIndex = 현재 선택되어있는 페이지
            // values.index = 현재 선택된 아이템 번호
            console.log('setContent')
            console.log(values)
            let firstContent = {}
            let content = []
            if (this.list.length) {
                if (values) {
                    firstContent = values
                } else {
                    // 클릭되지 않고 처음 들어오는 페이지 일경우 첫번째 아이템을 보여준다
                    firstContent = values
                    // firstContent = this.list[this.curPage][0]
                } 
                
                // 속보자료 첫화면에 띄워지는 컨텐츠 제어문
                if(this.checkFirst === false) {
                    this.checkFirst = true
                    firstContent = this.list[this.curPage][0]

                    // 22.04.15 suye 권한별 일자 제한: 첫게시글이 오늘일자와 동일하지 않도록           
                    // 유료회원 아닐때         
                    if(this.MEMBER_INFO === null || (this.MEMBER_INFO !== null && this.MEMBER_INFO.type !== 'REGULAR' && this.MEMBER_INFO.type !== 'CORPORATE')){
                        const today = this.limitDateMaker(0)
                        const contTemp = []
                        for (let i = 0; i < this.list.length; i++) {                    // 페이지당 들어오는 리스트 갯수
                            this.list[i].forEach(e => {                                 // 리스트의 sendDate값 <-> 오늘일자 비교 
                                if('sendDate' in e && e.sendDate !== null && e.sendDate !== undefined && e.sendDate !== ''){          // sendDate일 경우 
                                    if(today !== e.sendDate && today - e.sendDate >= 1){    // 오늘일자-1d -> 전일자 (주말동안 비어있는 경우 때문에 === -> >=)
                                        contTemp.push(e)
                                    }
                                } else if('showDate' in e && e.showDate !== null && e.showDate !== undefined && e.showDate !== '') {  // showDate일 경우
                                    if(today !== e.showDate && today - e.showDate >= 1){    
                                        contTemp.push(e)
                                    }
                                }
                            }); 
                        }
                        firstContent = contTemp[0] // 전일자의 첫 컨텐츠 현출
                    // 유료회원일때    
                    } else if(this.MEMBER_INFO.type === 'REGULAR' || this.MEMBER_INFO.type === 'CORPORATE'){       
                        firstContent = this.list[this.curPage][0]                                                       
                    }   
                }

                // 22.05.10 suye firstContent.newsType1 없을 시 오류 제거 
                if(firstContent && firstContent.newsType1){
                    if(firstContent.newsType1 !== undefined && firstContent.newsType1 !== null && firstContent.newsType1 !== ''){
    
                        const flag = getFileType(firstContent.newsType1)
                        //  html
                        let params = Object
                        let htmlfile = Object
                        let resContent = Object
                        switch (flag) {
                            case 'html':
                                params = {
                                    id: firstContent.id,
                                    newsType: firstContent.newsType1,
                                }
                                // tickerDetail에 flash/html 연결되어있음
                                htmlfile = await api.getTickerDetail(params)
                                firstContent.content = htmlfile.data.content
                                content = firstContent
                                break
                            default:
                                resContent = await this.GET_CONTENT({
                                    newsType: firstContent.newsType1,
                                    id: firstContent.id,
                                })
                                if (resContent) {
                                    content = resContent.newsItem
                                        ? resContent.newsItem
                                        : resContent
                                }
                        }
                        //  디테일 컴포넌트에 넘겨줌
                        this.slotData = content
                    }
                }
            }
        },
        /* 20210521 shb paging 관련  */
        onChangePage() {
            this.setContent()
        },
        onClickNext() {
            let prevkey = ''
            // createTime 을 nextkey 로 쓰는 경우
            //  api path - /market/board
            /* 
                220321 meej
                페이징 prevKey 수정
                현재페이지의 첫번째[this.curPage][0] 
                    -> 목록의 첫페이지의 첫번째[0][0] 
            */
            if (this.list[this.curPage][0].createTime) {
                prevkey = this.list[0][0].createTime
            } else {
                // sendDate+sendTime 을 nextkey 로 쓰는 경우
                //  api path - flash/list
                prevkey =
                    this.list[0][0].sendDate +
                    this.list[0][0].sendTime
            }
            this.SET_PREV_KEY(prevkey)
            this.SET_NEXT()
            this.getList(this.nextKey)

        },
        onClickPrev() {
            this.SET_PREV()
            this.getList(this.prevKey)
        },
    },
}
